"use strict";

exports.__esModule = true;
exports.default = void 0;
const warningStack = {};

const useWarning = (message, component) => {
  const tag = component ? ` [${component}]` : ' ';
  const log = `[Next UI]${tag}: ${message}`;
  if (typeof console === 'undefined') return;
  if (warningStack[log]) return;
  warningStack[log] = true;

  if (process.env.NODE_ENV !== 'production') {
    return console.error(log);
  }

  console.warn(log);
};

var _default = useWarning;
exports.default = _default;
module.exports = exports.default;